module.exports = __webpack_public_path__ + "media/images/indeed-logo-f3d57e1d91e36d889361f0bd97f14131.svg";